export default "__VITE_ASSET__BGnqL97X__"